import * as React from 'react';
import colors from '../../theme/colors';
import { NAVIGATION_TEXTS } from '../../theme/navigation';
import Menu from '../icons/Menu';
import NavigationItem from './item';
import './style.scss';
import Button, { ButtonLinkType } from '../Button';
import Text from '../Text';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import FlagIcon from '../Flags';
import { AvailableLanguages, PageLanguage } from '../../utils/langaugeTypes';
import { NavigationItem as NavigationItemType } from '../NavigationGroup';
import { I18nextContext } from 'gatsby-plugin-react-i18next';
import LanguageNavigationItem from './language-item';

interface Props {
  isOpen: boolean;
  onHamClick: React.Dispatch<React.SetStateAction<boolean>>;
  isOnTop?: boolean;
  headerBackgroundColor?: 'none' | 'light';
  currentPage?: string;
  pageLanguages?: PageLanguage[];
}

const NavigationMenu: React.FC<Props> = ({
  isOpen,
  onHamClick,
  isOnTop = false,
  headerBackgroundColor,
  currentPage,
  pageLanguages,
}) => {
  const { t } = useTranslation();
  const { language } = React.useContext(I18nextContext) as {
    language: AvailableLanguages;
  };

  const languagePages = React.useMemo((): NavigationItemType[] => {
    if (!pageLanguages) return [];

    return pageLanguages.map((item) => ({
      text: item.language.toUpperCase(),
      href: `/${item.slug}`,
      language: item.language,
      icon: <FlagIcon language={item.language} />,
    }));
  }, [pageLanguages]);

  const linkClassName =
    headerBackgroundColor === 'none'
      ? isOnTop
        ? 'dark-mode'
        : 'light-mode'
      : 'light-mode';

  const menuColor =
    headerBackgroundColor === 'none'
      ? isOnTop
        ? colors.main.backgroundColor.PRIMARY
        : colors.additional.greyColor.TUNDORA
      : colors.additional.greyColor.TUNDORA;

  const onClose = React.useCallback(() => {
    onHamClick(false);
  }, [onHamClick]);

  return (
    <div className="navigation-menu">
      <div
        onClick={() => onHamClick(!isOpen)}
        className="navigation-menu__button"
      >
        <Menu isActive={isOpen} color={menuColor} />
      </div>
      <div className="navigation-menu__menu">
        <div className="navigation-menu__menu__pages">
          {NAVIGATION_TEXTS?.map((item, index) => {
            const isCurrent = currentPage && currentPage === item.id;
            return (
              <NavigationItem
                {...item}
                key={`navigation-menu-${item.id}-${index}`}
                isCurrent={!!isCurrent}
                linkClassName={linkClassName}
                isOnTop={isOnTop}
              />
            );
          })}
          {pageLanguages && pageLanguages.length > 0 && (
            <LanguageNavigationItem
              id="languages"
              language={language}
              textId="navigation.languages"
              isCurrent={false}
              linkClassName={linkClassName}
              pages={languagePages}
              isOnTop={isOnTop}
              icon={<FlagIcon language={language} />}
            />
          )}
          <Button
            size="big"
            rounded
            color="secondary"
            className={classNames('navigation-menu__menu__contact', {
              open: isOpen,
            })}
            href="/#message-us"
            onClick={onClose}
            linkType={ButtonLinkType.ANCHOR}
          >
            <Text type="label" className="navigation-menu__menu__contact__text">
              {t('navigation_contact_us')}
            </Text>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NavigationMenu;
